import { useRef as t, useEffect as o, forwardRef as e, useState as n, useImperativeHandle as r, createElement as a } from "react";

function i() {
  return (i = Object.assign || function (t) {
    for (var o = 1; o < arguments.length; o++) {
      var e = arguments[o];

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var l = function l() {};

function c(t, o) {
  return Math.floor(Math.random() * (o - t + 1) + t);
}

var s = e(function (e, s) {
  var u = e.progress,
      d = e.height,
      f = void 0 === d ? 2 : d,
      v = e.className,
      p = void 0 === v ? "" : v,
      h = e.color,
      b = void 0 === h ? "red" : h,
      g = e.background,
      m = void 0 === g ? "transparent" : g,
      w = e.onLoaderFinished,
      y = e.transitionTime,
      x = void 0 === y ? 300 : y,
      S = e.loaderSpeed,
      k = void 0 === S ? 500 : S,
      R = e.waitingTime,
      T = void 0 === R ? 1e3 : R,
      Y = e.shadow,
      I = void 0 === Y || Y,
      O = n(0),
      j = O[0],
      M = O[1],
      N = n({
    active: !1,
    startingValue: 20,
    refreshRate: 1e3
  }),
      P = N[0],
      V = N[1],
      z = n(!1),
      F = z[0],
      L = z[1],
      q = n({
    active: !1,
    value: 20
  }),
      A = q[0],
      B = q[1],
      C = {
    position: "fixed",
    top: 0,
    left: 0,
    height: f,
    background: m,
    zIndex: 99999999999,
    width: "100%"
  },
      D = {
    boxShadow: "0 0 10px " + b + ", 0 0 10px " + b,
    width: "5%",
    opacity: 1,
    position: "absolute",
    height: "100%",
    transition: "all " + k + "ms ease",
    transform: "rotate(3deg) translate(0px, -4px)",
    left: "-10rem"
  },
      E = n({
    height: "100%",
    background: b,
    transition: "all " + k + "ms ease",
    width: "0%"
  }),
      G = E[0],
      H = E[1],
      J = n(D),
      K = J[0],
      Q = J[1];
  r(s, function () {
    return {
      continuousStart: function continuousStart(t, o) {
        if (void 0 === o && (o = 1e3), !A.active) if (F) console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");else {
          var e = t || c(10, 20);
          V({
            active: !0,
            refreshRate: o,
            startingValue: t
          }), M(e), Z(e);
        }
      },
      staticStart: function staticStart(t) {
        if (!P.active) if (F) console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!");else {
          var o = t || c(30, 50);
          B({
            active: !0,
            value: o
          }), M(o), Z(o);
        }
      },
      complete: function complete() {
        F ? console.warn("react-top-loading-bar: You can't use both controlling by props and ref methods to control the bar!") : (M(100), Z(100));
      }
    };
  }), o(function () {
    H(i({}, G, {
      background: b
    })), Q(i({}, K, {
      boxShadow: "0 0 10px " + b + ", 0 0 5px " + b
    }));
  }, [b]), o(function () {
    if (s) {
      if (s && void 0 !== u) return void console.warn('react-top-loading-bar: You can\'t use both controlling by props and ref methods to control the bar! Please use only props or only ref methods! Ref methods will override props if "ref" property is available.');
      Z(j), L(!1);
    } else u && Z(u), L(!0);
  }, [u]);

  var U,
      W,
      X,
      Z = function t(o) {
    o >= 100 ? (H(i({}, G, {
      width: "100%"
    })), I && Q(i({}, K, {
      left: o - 10 + "%"
    })), setTimeout(function () {
      H(i({}, G, {
        opacity: 0,
        width: "100%",
        transition: "all " + x + "ms ease-out",
        color: b
      })), setTimeout(function () {
        P.active && (V(i({}, P, {
          active: !1
        })), M(0), t(0)), A.active && (B(i({}, A, {
          active: !1
        })), M(0), t(0)), w && w(), M(0), t(0);
      }, x);
    }, T)) : (H(function (t) {
      return i({}, t, {
        width: o + "%",
        opacity: 1,
        transition: o > 0 ? "all " + k + "ms ease" : ""
      });
    }), I && Q(i({}, K, {
      left: o - 5.5 + "%",
      transition: o > 0 ? "all " + k + "ms ease" : ""
    })));
  };

  return U = function U() {
    var t = c(10, 20);
    j + t < 90 && (M(j + t), Z(j + t));
  }, W = P.active ? P.refreshRate : null, X = t(l), o(function () {
    X.current = U;
  }), o(function () {}, [void 0]), o(function () {
    if (null !== W && !1 !== W) {
      var t = setInterval(function () {
        return X.current();
      }, W);
      return function () {
        return clearInterval(t);
      };
    }
  }, [W]), a("div", {
    className: p,
    style: C
  }, a("div", {
    style: G
  }, I ? a("div", {
    style: K
  }) : null));
});
export default s;